/*
 * @Author       : yiyang
 * @Date         : 2020-09-02 16:31:20
 * @LastEditors  : yiyang
 * @LastEditTime : 2021-02-04 11:43:49
 * @PRD          : 
 * @Description  : 
 * @FilePath     : /work/yit_fe_shangbo/src/routes/graphic/index.js
 * @URL          : 
 */
import React, { Component } from "react"
// import { useHistory } from 'react-router-dom'
import { getGraphic } from "services/graphic"
import GraphicLayout from 'layouts/GraphicLayout/index'
import Item from "./Item"
import Share from "./Share"
import config from "config/default"
// import { COVER_PATH } from 'routes/path'
import NETImage from 'components/net-image'

/**
 * 课程主题页
 */
export default class GraphicRoute extends Component {
    state = {
        graphic: undefined,
    }
    componentDidMount() {
        this.initPage();
    }

    get theme() {
        const { theme = 'hsh' } = this.props.match.params
        return theme
    }
    
    async initPage() {
        // console.log(this.theme)
        // 获取数据
        const graphicData = await getGraphic({
            theme: this.theme,
        });
        if (graphicData) {
            // 设置内容展示
            this.setState({
                graphic: graphicData,
            });
        } else {
            this.setState({
                graphic: null,
            });
        }

        // console.log('graphicData', graphicData)
        // document.title = graphicData.shareInfo.title;
    }

    render() {
        let graphicData = this.state.graphic;
        const onSelect = () => {
            if (graphicData && graphicData.firstInfo && graphicData.firstInfo.linkUrl) {
                // history.push(COVER_PATH())
                window.location.href = graphicData.firstInfo.linkUrl;
            }
        }

        // if (this.theme === 'zodiac') {
        //     return (<div className="construction">页面维护中，敬请期待...</div>)
        // }

        // 图片路径
        let imgPrefix = 'graphic/' + this.theme + '/';

        // console.log('graphicData', graphicData)
        // 分享设置
        let configs;
        if (graphicData && graphicData.shareInfo) {
            configs = {
                ...config,
                ...graphicData.shareInfo,
                imgUrl: graphicData.shareInfo.imgUrl ? config.cdnUrl + '/' + imgPrefix + graphicData.shareInfo.imgUrl : undefined,
            };
        }

        return (
            graphicData ? <GraphicLayout pageTitle={graphicData.shareInfo.title}>
                <Share config={configs} />
                <div className="first_item" onClick={onSelect}>
                    <div className="img_box">
                        {/* <img src={graphicData.firstInfo.imgUrl} alt="" className="img" /> */}
                        <NETImage
                            prefix={imgPrefix}
                            useAutoHeight
                            src={graphicData.firstInfo.imgUrl}
                            className='img'
                        />
                    </div>
                    <div className="text">{graphicData.firstInfo.title}</div>
                </div>

                <div className="list">
                    {
                        graphicData.listInfo.map((item, i) => (
                            <Item key={this.theme + '_' + i} item={item} theme={imgPrefix} />
                        ))
                    }
                </div>
            </GraphicLayout> : (graphicData !== undefined && <div className="page404">
                    <div className="title">404</div>
                    <div className="desc">页面不存在。。。</div>
            </div>)
        )
    }
}